/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, dateTime: NonNullable<unknown> }} Coinvestments_Senddrafts_Toast_Scheduledother3Inputs */

const en_coinvestments_senddrafts_toast_scheduledother3 = /** @type {(inputs: Coinvestments_Senddrafts_Toast_Scheduledother3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} drafts scheduled for ${i?.dateTime}`)
};

/**
* | output |
* | --- |
* | "{count} drafts scheduled for {dateTime}" |
*
* @param {Coinvestments_Senddrafts_Toast_Scheduledother3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_senddrafts_toast_scheduledother3 = /** @type {((inputs: Coinvestments_Senddrafts_Toast_Scheduledother3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Senddrafts_Toast_Scheduledother3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_senddrafts_toast_scheduledother3(inputs)
});
export { coinvestments_senddrafts_toast_scheduledother3 as "coInvestments_sendDrafts_toast_scheduledOther" }